import React from "react";
import { View } from "native-base";
import { MoveDiagonal2 } from "lucide-react-native";

type ResizeHandleProps = {
  scaleAll: number;
  panHandlers: object;
};

const ResizeHandle: React.FC<ResizeHandleProps> = ({ scaleAll, panHandlers }) => {
  return (
    <View
      {...panHandlers}
      style={{
        position: "absolute",
        right: 10 * scaleAll,
        bottom: 10 * scaleAll,
        width: 28 * scaleAll,
        height: 28 * scaleAll,
        borderRadius: 10 * scaleAll,
        backgroundColor: "#F4F1EB",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <MoveDiagonal2 size={14 * scaleAll} color="#6F685F" />
    </View>
  );
};

export default React.memo(ResizeHandle);
